import { useEffect, useState } from "react";

// Dependencies
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

// Landing page
const LandingPage = () => {
  // Hooks
  const navigate = useNavigate();

  // States
  const [day1, setDay1] = useState(0);
  const [day2, setDay2] = useState(0);

  const [hour1, setHour1] = useState(0);
  const [hour2, setHour2] = useState(0);

  const [minute1, setMinute1] = useState(0);
  const [minute2, setMinute2] = useState(0);

  const [second1, setSecond1] = useState(0);
  const [second2, setSecond2] = useState(0);

  const [activeRoadmapPhase, setActiveRoadmapPhase] = useState(0);

  // Functions
  const countDown = () => {
    const dueDate = new Date("Apr 28, 2023 17:00").getTime();
    const currentDate = new Date().getTime();

    const remainings = dueDate - currentDate;

    if (remainings > 0) {
      let second = 1000;
      let minute = second * 60;
      let hour = minute * 60;
      let day = hour * 24;

      // Remaining
      let remainingDay = Math.floor(remainings / day);
      let remainingHour = Math.floor((remainings % day) / hour);
      let remainingMinute = Math.floor((remainings % hour) / minute);
      let remainingSecond = Math.floor((remainings % minute) / second);

      // Day
      let dayLength = remainingDay.toString().length;

      if (dayLength === 1) {
        setDay1(0);
        setDay2(remainingDay);
      } else if (dayLength === 2) {
        remainingDay = remainingDay.toString().split("");

        setDay1(remainingDay[0]);
        setDay2(remainingDay[1]);
      }

      // Hour
      let hourLength = remainingHour.toString().length;

      if (hourLength === 1) {
        setHour1(0);
        setHour2(remainingHour);
      } else if (hourLength === 2) {
        remainingHour = remainingHour.toString().split("");

        setHour1(remainingHour[0]);
        setHour2(remainingHour[1]);
      }

      // Minute
      let minuteLength = remainingMinute.toString().length;

      if (minuteLength === 1) {
        setMinute1(0);
        setMinute2(remainingMinute);
      } else if (minuteLength === 2) {
        remainingMinute = remainingMinute.toString().split("");

        setMinute1(remainingMinute[0]);
        setMinute2(remainingMinute[1]);
      }

      // Second
      let secondLength = remainingSecond.toString().length;

      if (secondLength === 1) {
        setSecond1(0);
        setSecond2(remainingSecond);
      } else if (secondLength === 2) {
        remainingSecond = remainingSecond.toString().split("");

        setSecond1(remainingSecond[0]);
        setSecond2(remainingSecond[1]);
      }
    } else {
      setDay1(0);
      setDay2(0);

      setHour1(0);
      setHour2(0);

      setMinute1(0);
      setMinute2(0);

      setSecond1(0);
      setSecond2(0);
    }
  };

  useEffect(() => {
    const interval = setInterval(countDown, 1000);

    return () => clearInterval(interval);
  }, []);

  // Content
  const content_roadmap_phases = [
    {
      title: "Milestone",
      text: `We are paying back our community when we hit sell through percentages! 🚀<br />
      <p style="line-height: 20px;"><br /></p>

      <div class="div-row">
        <div class="div-column-1"><p style="color: #F5DA49;"><b>20%</b></p></div>
        <div class="div-column-2"><p>We release free additional airdrop opportunities to our random cat holders. We want to appreciate those who support our journey!</p></div>
      </div>
      <p style="line-height: 20px;"><br /></p>

      <div class="div-row">
        <div class="div-column-1"><p style="color: #F5DA49;"><b>40%</b></p></div>
        <div class="div-column-2"><p>One of our key values is supporting others! we will give back to the community by supporting NGOs and charities such as No Kid Hungry.</p></div>
      </div>
      <p style="line-height: 20px;"><br /></p>
      
      <div class="div-row">
        <div class="div-column-1"><p style="color: #F5DA49;"><b>60%</b></p></div>
        <div class="div-column-2"><p>We unlock Funky Cat member exclusive online stores, featuring limited edition t-shirts, hoodies, accessories, and other goodies.</p></div>
      </div>
      <p style="line-height: 20px;"><br /></p>
      
      <div class="div-row">
        <div class="div-column-1"><p style="color: #F5DA49;"><b>80%</b></p></div>
        <div class="div-column-2"><p>We give back to the community and reward those who are bold, driven, and authentic. 3 ETH price for the final winner!</p></div>
      </div>
      <p style="line-height: 20px;"><br /></p>
      
      <div class="div-row">
        <div class="div-column-1"><p style="color: #F5DA49;"><b>100%</b></p></div>
        <div class="div-column-2"><p>We partner with influencers and throw FREE sell-out parties for verified Funky Cat holders. Let’s funk it together!</p></div>
      </div>
      <p style="line-height: 20px;"><br /></p>
      
      <b>Exclusive Perks:</b> Our journey doesn’t stop here. All Funky Cat holders will receive early access and whitelist opportunities to future Funky Club NFT collections, games, and influencer events!
      `,
    },
    // {
    //   title: "Phase 2",
    //   text: `The BAYC Bathroom will become operational once the presale period
    //           is over. It contains a canvas accessible only to wallets
    //           containing at least one ape. Like any good dive bar bathroom, this
    //           is the place to draw, scrawl, or write expletives. <br />
    //           <br /> Each ape-holder will be able to paint a pixel on the
    //           bathroom wall every fifteen minutes. Think of it as a
    //           collaborative art experiment for the cryptosphere. A members-only
    //           canvas for the discerning minds of crypto twitter. <br />
    //           <br /> The BAYC Bathroom will become operational once the presale
    //           period is over. It contains a canvas accessible only to wallets
    //           containing at least one ape.`,
    // },
    // {
    //   title: "Phase 3",
    //   text: `The BAYC Bathroom will become operational once the presale period
    //           is over. It contains a canvas accessible only to wallets
    //           containing at least one ape. Like any good dive bar bathroom, this
    //           is the place to draw, scrawl, or write expletives. <br />
    //           <br /> Each ape-holder will be able to paint a pixel on the
    //           bathroom wall every fifteen minutes. Think of it as a
    //           collaborative art experiment for the cryptosphere. A members-only
    //           canvas for the discerning minds of crypto twitter. <br />
    //           <br /> The BAYC Bathroom will become operational once the presale
    //           period is over. It contains a canvas accessible only to wallets
    //           containing at least one ape.`,
    // },
    // {
    //   title: "Phase 4",
    //   text: `The BAYC Bathroom will become operational once the presale period
    //           is over. It contains a canvas accessible only to wallets
    //           containing at least one ape. Like any good dive bar bathroom, this
    //           is the place to draw, scrawl, or write expletives. <br />
    //           <br /> Each ape-holder will be able to paint a pixel on the
    //           bathroom wall every fifteen minutes. Think of it as a
    //           collaborative art experiment for the cryptosphere. A members-only
    //           canvas for the discerning minds of crypto twitter. <br />
    //           <br /> The BAYC Bathroom will become operational once the presale
    //           period is over. It contains a canvas accessible only to wallets
    //           containing at least one ape.`,
    // },
  ];

  return (
    <main className="landing-page">
      {/* Hero section */}
      <section className="hero">
        <motion.img
          initial={{ x: "100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          src="/images/pages/landing-page/hero-img-2.png"
          alt=""
          className="hero-img-2"
        />

        <motion.img
          initial={{ x: "-100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          src="/images/pages/landing-page/hero-img-4.png"
          alt=""
          className="hero-img-4"
        />

        <div className="container">
          <motion.img
            initial={{ y: "-100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            src="/images/pages/landing-page/hero-img-1.png"
            alt=""
            className="hero-img-1"
          />

          <motion.img
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            src="/images/pages/landing-page/hero-img-3.png"
            alt=""
            className="hero-img-3"
          />

          <motion.img
            initial={{ scale: 1.2, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, delay: 1 }}
            src="/images/pages/landing-page/hero-img-6.png"
            alt=""
            className="hero-img-6"
          />

          <motion.img
            initial={{ scale: 1.2, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, delay: 1.3 }}
            src="/images/pages/landing-page/hero-img-7.png"
            alt=""
            className="hero-img-7"
          />

          <motion.img
            initial={{ scale: 1.2, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, delay: 1.6 }}
            src="/images/pages/landing-page/hero-img-8.png"
            alt=""
            className="hero-img-8"
          />

          <motion.img
            initial={{ scale: 1.2, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, delay: 1.9 }}
            src="/images/pages/landing-page/hero-img-9.png"
            alt=""
            className="hero-img-9"
          />

          <div className="content">
            <div className="title">
              <h1>
                <span>Funky</span> <br /> Cat Club
              </h1>

              <motion.img
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, delay: 2.2 }}
                src="/images/pages/landing-page/hero-img-5.png"
                alt=""
              />
            </div>

            <div className="countdown-box">
              <div className="countdown-box-part">
                <div className="countdown-box-part-box">
                  <h3>
                    {day1}
                    {day2}
                  </h3>
                </div>

                <p>Days</p>
              </div>

              <div className="countdown-box-part">
                <div className="countdown-box-part-box">
                  <h3>
                    {hour1}
                    {hour2}
                  </h3>
                </div>

                <p>Hours</p>
              </div>

              <div className="countdown-box-part">
                <div className="countdown-box-part-box">
                  <h3>
                    {minute1}
                    {minute2}
                  </h3>
                </div>

                <p>Minutes</p>
              </div>

              <div className="countdown-box-part">
                <div className="countdown-box-part-box">
                  <h3>
                    {second1}
                    {second2}
                  </h3>
                </div>

                <p>Seconds</p>
              </div>
            </div>

            {/* <motion.button
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              onClick={() => {
                navigate("/mint");
              }}
            >
              Get Your NFTs Now
            </motion.button> */}

            <motion.button
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              onClick={() => {
                navigate("/mint");
              }}
            >
              Whitelist Mint Access
            </motion.button>

            {/* <motion.button
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              onClick={() => {
                window.open("https://discord.gg/pAZEm5FPjs");
              }}
            >
              Join Our Discord
            </motion.button> */}

            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="social-links"
            >
              <a href="https://discord.gg/pAZEm5FPjs" target="_blank">
                <svg
                  width="23"
                  height="15"
                  viewBox="0 0 23 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.4704 1.24345C17.9793 0.6578 16.4056 0.240173 14.7889 0.00103071C14.7742 -0.00131654 14.759 0.000370974 14.7455 0.00583031C14.7321 0.0112896 14.7209 0.0202569 14.7137 0.0314525C14.5115 0.339193 14.2874 0.74056 14.1308 1.056C12.3629 0.829532 10.6041 0.829532 8.87259 1.056C8.71575 0.733518 8.48356 0.339193 8.28058 0.0314525C8.27298 0.0205074 8.26189 0.0117645 8.24845 0.00635787C8.23502 0.000938093 8.21998 -0.000881267 8.20537 0.00110994C6.58836 0.239699 5.01467 0.657285 3.52369 1.24337C3.51094 1.24804 3.50019 1.25598 3.49293 1.26608C0.511185 5.07758 -0.305701 8.79547 0.0950681 12.4672C0.0962071 12.4762 0.0994341 12.4849 0.104574 12.4928C0.1097 12.5007 0.116636 12.5077 0.124975 12.5132C2.09223 13.7494 3.99787 14.4999 5.86814 14.9974C5.88274 15.0009 5.89822 15.0008 5.91268 14.9967C5.92713 14.9927 5.93969 14.985 5.94889 14.9747C6.39122 14.4578 6.78551 13.9126 7.12372 13.3395C7.12839 13.3316 7.13102 13.323 7.1316 13.3142C7.13204 13.3055 7.13029 13.2967 7.12664 13.2885C7.12284 13.2803 7.117 13.2728 7.1097 13.2667C7.1024 13.2605 7.09349 13.2558 7.08385 13.2527C6.45825 13.0498 5.86273 12.8023 5.2897 12.5211C5.27926 12.5159 5.27047 12.5085 5.26415 12.4996C5.25783 12.4908 5.25413 12.4808 5.25342 12.4704C5.25269 12.4601 5.25496 12.4497 5.26002 12.4403C5.26508 12.4308 5.27278 12.4226 5.28242 12.4164C5.40298 12.3392 5.52363 12.2587 5.63872 12.1774C5.64896 12.1702 5.66136 12.1656 5.6745 12.164C5.68764 12.1626 5.70093 12.1642 5.71305 12.1688C9.47716 13.6392 13.5522 13.6392 17.2719 12.1688C17.284 12.1639 17.2974 12.1619 17.3109 12.1634C17.3242 12.1648 17.3367 12.1693 17.3471 12.1767C17.4623 12.2578 17.5829 12.3392 17.7044 12.4164C17.7141 12.4226 17.7218 12.4308 17.7269 12.4402C17.732 12.4495 17.7344 12.4598 17.7338 12.4701C17.7332 12.4805 17.7296 12.4905 17.7234 12.4994C17.7171 12.5082 17.7084 12.5157 17.698 12.521C17.1248 12.8074 16.5244 13.052 15.9031 13.252C15.8935 13.2551 15.8847 13.26 15.8774 13.2662C15.8701 13.2725 15.8644 13.2799 15.8608 13.2882C15.8571 13.2965 15.8555 13.3052 15.8561 13.3142C15.8567 13.323 15.8595 13.3316 15.8641 13.3395C16.2095 13.9118 16.6038 14.457 17.0381 14.9739C17.047 14.9844 17.0596 14.9925 17.074 14.9967C17.0885 15.0009 17.1041 15.001 17.1187 14.9974C18.9981 14.4997 20.9037 13.7494 22.871 12.5132C22.8794 12.508 22.8865 12.5011 22.8916 12.4933C22.8969 12.4855 22.9 12.4768 22.901 12.468C23.3805 8.22303 22.0977 4.5356 19.5003 1.26682C19.4941 1.2562 19.4834 1.24788 19.4704 1.24337V1.24345ZM7.68579 10.2315C6.55259 10.2315 5.61879 9.34127 5.61879 8.24809C5.61879 7.15477 6.53448 6.26453 7.68594 6.26453C8.8463 6.26453 9.77098 7.16255 9.75287 8.24809C9.75287 9.34127 8.8371 10.2315 7.68579 10.2315ZM15.3284 10.2315C14.1952 10.2315 13.2613 9.34127 13.2613 8.24809C13.2613 7.15477 14.1769 6.26453 15.3284 6.26453C16.4887 6.26453 17.4134 7.16255 17.3953 8.24809C17.3953 9.34127 16.4887 10.2315 15.3284 10.2315Z"
                    fill="white"
                  />
                </svg>
              </a>

              <a href="https://opensea.io/collection/funky-cat-club" target="_blank">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 10.5C21 16.2987 16.2987 21 10.5 21C4.70135 21 0 16.2987 0 10.5C0 4.70135 4.70135 0 10.5 0C16.2999 0 21 4.70135 21 10.5ZM5.18026 10.8528L5.22557 10.7816L7.95701 6.50856C7.99691 6.446 8.09075 6.45242 8.12103 6.52039C8.57728 7.54309 8.97109 8.81503 8.78662 9.60684C8.70782 9.93267 8.49207 10.3738 8.24935 10.7816C8.21807 10.841 8.18359 10.8992 8.14689 10.9553C8.12965 10.9812 8.10047 10.9963 8.06919 10.9963H5.26006C5.18457 10.9963 5.14036 10.9143 5.18026 10.8528ZM17.3553 12.3232V11.6468C17.3553 11.5843 17.295 11.5389 17.2357 11.5562L14.0414 12.4796C14.0241 12.4839 14.009 12.4937 13.9971 12.5066C13.655 12.8845 13.3643 13.138 13.2873 13.2052L13.2818 13.2099C13.0833 13.3782 12.8374 13.47 12.5784 13.47H11.422V12.2909H12.3411C12.3649 12.2909 12.3876 12.2822 12.4048 12.2671L12.5235 12.1581C12.5742 12.1118 12.6346 12.0557 12.7069 11.9834C12.713 11.9772 12.7193 11.971 12.7256 11.9648C12.7635 11.9269 12.8041 11.8864 12.8439 11.8421C12.8913 11.7957 12.9378 11.7439 12.9809 11.6932C13.0532 11.6155 13.1222 11.5346 13.1945 11.4494C13.2462 11.3933 13.2938 11.3296 13.3401 11.2659C13.3919 11.2056 13.4427 11.1376 13.4901 11.0729C13.5078 11.0469 13.5265 11.0207 13.5458 10.9938C13.5641 10.9683 13.5828 10.9422 13.6011 10.9154C13.6357 10.8636 13.6702 10.8086 13.6994 10.7568C13.7899 10.6166 13.8666 10.4666 13.9313 10.3166C13.961 10.2524 13.9848 10.1848 14.0079 10.1191C14.0108 10.1108 14.0136 10.1027 14.0165 10.0945C14.0424 10.0179 14.064 9.9456 14.0802 9.86901C14.119 9.68885 14.1276 9.50968 14.1103 9.33063C14.106 9.27459 14.1017 9.21955 14.0888 9.16772V9.1592C14.0845 9.1224 14.0759 9.0815 14.064 9.0437C14.0251 8.86896 13.9648 8.69422 13.8882 8.52268C13.8622 8.45902 13.832 8.39425 13.803 8.3349C13.7339 8.20658 13.6616 8.07815 13.5796 7.95414C13.5631 7.92794 13.545 7.90142 13.5269 7.87489C13.5128 7.85444 13.4989 7.83411 13.4858 7.81388C13.4338 7.73386 13.3755 7.6566 13.3189 7.58166C13.306 7.56475 13.2933 7.54795 13.2807 7.53126C13.2474 7.48738 13.2108 7.44351 13.1739 7.39929C13.1537 7.37498 13.1334 7.35077 13.1136 7.32624C13.0575 7.25837 13.0024 7.1936 12.9464 7.12994C12.7457 6.90336 12.5353 6.69845 12.3477 6.52371C12.3131 6.48922 12.2754 6.45463 12.2365 6.42125C12.0909 6.28851 11.9582 6.17312 11.8471 6.08359C11.8137 6.05784 11.7838 6.03253 11.7559 6.00898C11.7369 5.99296 11.7189 5.97782 11.7014 5.96378C11.6678 5.93869 11.6385 5.91636 11.614 5.89768C11.5984 5.88586 11.5848 5.87547 11.5731 5.86674C11.5645 5.86022 11.5548 5.8559 11.545 5.8527L11.422 5.81822V4.79983C11.422 4.63371 11.3551 4.48483 11.2484 4.37585C11.1416 4.26687 10.9927 4.2 10.8287 4.2C10.5008 4.2 10.2354 4.46858 10.2354 4.79983V5.48586L10.1739 5.46862L10.0067 5.4212L9.85464 5.3791C9.85353 5.3791 9.85243 5.37799 9.85033 5.37799H9.84701L8.69278 5.0652C8.64205 5.05116 8.59895 5.10621 8.62481 5.15252L8.80928 5.49349C8.81978 5.51968 8.83304 5.54588 8.84664 5.57274C8.85548 5.5902 8.86443 5.60788 8.87294 5.62612C8.90312 5.68658 8.93329 5.75013 8.96247 5.8138C8.98833 5.86994 9.01419 5.92498 9.04448 5.98533C9.05708 6.01374 9.07012 6.04258 9.08316 6.07165C9.13146 6.17875 9.18208 6.29138 9.23215 6.41252C9.27526 6.51508 9.31847 6.61754 9.35616 6.72431C9.45973 6.993 9.55787 7.27993 9.6432 7.57437C9.66442 7.64035 9.68133 7.70413 9.69846 7.76878C9.70576 7.79619 9.71316 7.82372 9.72079 7.85168L9.73273 7.9034C9.76721 8.04046 9.79738 8.17641 9.81905 8.31335C9.83629 8.40718 9.85243 8.49682 9.86105 8.58734C9.87398 8.6898 9.88691 8.79237 9.89133 8.89483C9.89995 8.98866 9.90426 9.08692 9.90426 9.18076C9.90426 9.42016 9.8826 9.65105 9.83198 9.86901C9.82877 9.88072 9.82557 9.89255 9.82236 9.90448C9.80822 9.95754 9.79341 10.0125 9.77583 10.0653C9.75992 10.1219 9.73925 10.1785 9.7178 10.2372C9.71018 10.2579 9.70255 10.2791 9.69493 10.3005C9.69349 10.3043 9.69205 10.3081 9.69062 10.312C9.67481 10.3547 9.65867 10.3982 9.63878 10.4408C9.53201 10.6975 9.39938 10.9532 9.26233 11.1927C9.06172 11.5476 8.86001 11.8594 8.71865 12.06C8.71003 12.0729 8.70152 12.0853 8.69345 12.0971C8.68328 12.1119 8.67366 12.1261 8.66471 12.1398C8.6205 12.2023 8.66582 12.2909 8.74241 12.2909H10.2354V13.47H8.72506C8.31954 13.47 7.94408 13.2402 7.76282 12.8723C7.66898 12.6879 7.63228 12.4851 7.65395 12.2865C7.65925 12.2272 7.61504 12.171 7.55469 12.171H4.50384C4.45211 12.171 4.41 12.2132 4.41 12.2649V12.3276C4.41 14.2736 5.98179 15.8508 7.92142 15.8508H13.394C14.4199 15.8508 15.0024 14.916 15.5749 13.9972C15.7345 13.7411 15.8934 13.4862 16.0608 13.2531C16.3618 12.8345 17.0857 12.5023 17.297 12.4117C17.3316 12.3965 17.3553 12.362 17.3553 12.3232Z"
                    fill="white"
                  />
                </svg>
              </a>

              <a href="https://twitter.com/FunkyCatClub" target="_blank">
                <svg
                  width="20"
                  height="14"
                  viewBox="0 0 20 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9442 3.48904C17.9569 3.64213 17.9569 3.79532 17.9569 3.94841C17.9569 8.61872 13.8325 14 6.29447 14C3.97205 14 1.81468 13.4202 0 12.414C0.329962 12.4468 0.647189 12.4578 0.989852 12.4578C2.90608 12.4578 4.67003 11.9 6.07868 10.9485C4.27671 10.9157 2.76647 9.8984 2.24614 8.49843C2.50005 8.53124 2.75375 8.55311 3.02027 8.55311C3.38838 8.55311 3.75638 8.50937 4.09896 8.43282C2.22082 8.10468 0.812153 6.68284 0.812153 4.96565V4.92191C1.35781 5.18435 1.99244 5.34848 2.66499 5.37025C1.56088 4.73592 0.837546 3.65307 0.837546 2.42805C0.837546 1.77186 1.04055 1.17034 1.39595 0.645262C3.4137 2.78901 6.44668 4.18898 9.84767 4.34216C9.78422 4.07963 9.74619 3.80625 9.74619 3.53278C9.74619 1.58596 11.5736 0 13.8451 0C15.0254 0 16.0914 0.426562 16.8401 1.11566C17.7665 0.962474 18.6548 0.667131 19.4416 0.262537C19.137 1.08286 18.4899 1.77186 17.6396 2.20935C18.4644 2.13281 19.264 1.93588 20 1.66251C19.4418 2.36244 18.7437 2.98593 17.9442 3.48904Z"
                    fill="white"
                  />
                </svg>
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* About section */}
      <section className="about">
        <div className="container">
          <img
            src="/images/pages/landing-page/about-img-1.png"
            alt=""
            className="about-img-1"
          />

          <img
            src="/images/pages/landing-page/about-img-2.png"
            alt=""
            className="about-img-2"
          />

          {/* <img
            src="/images/pages/landing-page/about-img-3.png"
            alt=""
            className="about-img-3"
          /> */}

          <motion.h2
            initial={{ y: -20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <span>About the</span> <br /> Collection
          </motion.h2>

          <motion.p
            initial={{ y: -20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            Introducing the Funky Cat Club <br /> 
            Funky Cat Club is a collection of 7,777 unique whimsical cats 
            built on the Ethereum blockchain. <br /> The Funky Cats Club 
            partners with global influencers, and we welcome all dreamers and doers 
            <br /> who are bold, driven, and authentic.
          </motion.p>

          {/* <div>
            <video width="640" height="360" controls>
              <source src="https://www.youtube.com/watch?v=InrI65i7ZL4" type="video/mp4"></source>
              Your browser does not support the video tag.
            </video>
          </div> */}
        </div>
      </section>

      {/* NFT section */}
      <section className="nft">
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="slides"
        >
          <div className="slide">
            <img src="/images/pages/landing-page/nft-img-1.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-2.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-3.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-4.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-5.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-6.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-7.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-8.png" alt="" />
          </div>

          <div className="slide">
            <img src="/images/pages/landing-page/nft-img-9.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-10.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-11.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-12.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-13.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-14.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-15.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-16.png" alt="" />
          </div>

          <div className="slide">
            <img src="/images/pages/landing-page/nft-img-1.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-2.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-3.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-4.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-5.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-6.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-7.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-8.png" alt="" />
          </div>

          <div className="slide">
            <img src="/images/pages/landing-page/nft-img-9.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-10.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-11.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-12.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-13.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-14.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-15.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-16.png" alt="" />
          </div>
        </motion.div>
      </section>

      {/* NFT section */}
      <section className="nft nft-2">
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="slides"
        >
          <div className="slide">
            <img src="/images/pages/landing-page/nft-img-17.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-18.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-19.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-20.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-21.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-22.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-23.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-24.png" alt="" />
          </div>

          <div className="slide">
            <img src="/images/pages/landing-page/nft-img-25.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-26.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-27.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-28.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-29.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-30.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-31.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-32.png" alt="" />
          </div>

          <div className="slide">
            <img src="/images/pages/landing-page/nft-img-17.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-18.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-19.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-20.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-21.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-22.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-23.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-24.png" alt="" />
          </div>

          <div className="slide">
            <img src="/images/pages/landing-page/nft-img-25.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-26.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-27.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-28.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-29.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-30.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-31.png" alt="" />
            <img src="/images/pages/landing-page/nft-img-32.png" alt="" />
          </div>
        </motion.div>
      </section>

      {/* Mission section */}
      <section className="mission">
        <div className="container">
          <img
            src="/images/pages/landing-page/mission-bg-img-1.png"
            alt=""
            className="mission-bg-img-1"
          />

          <img
            src="/images/pages/landing-page/mission-img-2.png"
            alt=""
            className="mission-img-2"
          />

          <img
            src="/images/pages/landing-page/mission-img-3.png"
            alt=""
            className="mission-img-3"
          />

          <div className="content">
            <motion.h2
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <span>Our Funky</span> <br /> Mission
            </motion.h2>

            <motion.p
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              The Funky Cat Club is pleased to announce the release of its exclusive collection of 7,777 unique NFTs built on the Ethereum blockchain. With a launch date set on March 25th, the Funky Cat Club aims to unite dreamers and doers who embrace their unique identities and attitude.
              The Funky Cat Club is the brainchild of top-tier design industry and tech companies founders, who have pooled their extensive expertise to create a collection of whimsical cats that stand out in the NFT space. The Funky Cat Club partners with global influencers and brands that have millions of followers, adding an extra layer of exclusivity to the collection.
              Our cats are not just cute and quirky, but they’re also a symbol of attitude and authenticity. We’re thrilled to welcome anyone who shares our vision and values to join the club and claim their own unique cat.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Team section */}
      <section className="team">
        <img
          src="/images/pages/landing-page/team-img-7.png"
          alt=""
          className="team-img-7"
        />

        <div className="container">
          <motion.h2
            initial={{ y: -20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <span>The Funky</span> <br /> Team
          </motion.h2>

          <div className="boxes">
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="box"
            >
              <img src="/images/pages/landing-page/team-img-1.png" alt="" />

              <h3>Alex</h3>

              <p>Co-Founder, Art Director</p>
            </motion.div>

            <motion.div
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="box"
            >
              <img src="/images/pages/landing-page/team-img-2.png" alt="" />

              <h3>GGBond</h3>

              <p>Co-Founder, Tech Lead</p>
            </motion.div>

            <motion.div
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="box"
            >
              <img src="/images/pages/landing-page/team-img-3.png" alt="" />

              <h3>Arrohan</h3>

              <p>Co-Founder, Tech Lead</p>
            </motion.div>

            <motion.div
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="box"
            >
              <img src="/images/pages/landing-page/team-img-4.png" alt="" />

              <h3>Believer</h3>

              <p>Marketing Lead, Comm Manager</p>
            </motion.div>

            <motion.div
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className="box"
            >
              <img src="/images/pages/landing-page/team-img-5.png" alt="" />

              <h3>Alison</h3>

              <p>Community Manager</p>
            </motion.div>

            <motion.div
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              className="box"
            >
              <img src="/images/pages/landing-page/team-img-6.png" alt="" />

              <h3>Harris</h3>

              <p>Social Media Lead</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Roadmap section */}
      <section className="roadmap">
        <div className="container">
          <motion.h2
            initial={{ y: -20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <span>The Ultimate</span> <br /> Roadmap
          </motion.h2>

          <motion.img
            initial={{ x: -20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            src="/images/pages/landing-page/roadmap-img-2.png"
            alt=""
            className="roadmap-img-2"
          />

          <img
            src="/images/pages/landing-page/roadmap-img-3.png"
            alt=""
            className="roadmap-img-3"
          />

          <motion.div
            initial={{ y: -20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="roadmap-content"
          >
            <div className="roadmap-phases">
              {content_roadmap_phases.map((phase, index) => {
                return (
                  <button
                    key={index}
                    className={activeRoadmapPhase === index && "active"}
                    onClick={() => {
                      setActiveRoadmapPhase(index);
                    }}
                  >
                    <img
                      src="/images/pages/landing-page/roadmap-img-1.png"
                      alt=""
                    />

                    <span>{phase.title}</span>
                  </button>
                );
              })}
            </div>

            <p
              dangerouslySetInnerHTML={{
                __html: content_roadmap_phases[activeRoadmapPhase].text,
              }}
            ></p>
          </motion.div>
        </div>
      </section>

      {/* Texts section */}
      <section className="texts">
        <div className="text">
          <div className="slides">
            <div className="slide">
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
            </div>

            <div className="slide">
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
            </div>

            <div className="slide">
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
            </div>

            <div className="slide">
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
            </div>
          </div>
        </div>

        <div className="text-2">
          <div className="slides">
            <div className="slide">
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
            </div>

            <div className="slide">
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
            </div>

            <div className="slide">
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
            </div>

            <div className="slide">
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
              <p>The Whimsical Cats</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

// Export
export default LandingPage;
